import React from "react";

const LinktreeBrand1 = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.625 0C7.78875 0 0.625 7.16375 0.625 16C0.625 24.8363 7.78875 32 16.625 32C25.4613 32 32.625 24.8363 32.625 16C32.625 7.16375 25.4613 0 16.625 0Z"
      fill="#43E660"
    />
    <path
      d="M15.0213 19.6993H18.2132V26.6667H15.0213V19.6993ZM7.64258 12.5578H13.0738L9.21272 8.9995L11.3492 6.87612L15.03 10.534V5.33337H18.2217V10.534L21.9025 6.88444L24.0373 8.9995L20.178 12.5495H25.6075V15.4857H20.147L24.0322 19.1353L21.9025 21.209L16.6259 16.083L11.3492 21.209L9.21272 19.1437L13.0994 15.4941H7.64258V12.5578Z"
      fill="black"
    />
  </svg>
);

export default LinktreeBrand1;
